module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.nalaganje) ? _c('div', [_c('div', {
    staticClass: "rating-grid"
  }, [(_vm.ratingDeviation > 87.5) ? _c('leaderboard-card', {
    attrs: {
      "showInfo": "true",
      "progress": (1 - _vm.ratingDeviation / 350) * 100
    }
  }) : _vm._e(), _vm._v(" "), _c('rating-quiz-button', {
    attrs: {
      "gid": _vm.gid,
      "sid": "root",
      "yid": _vm.yid
    }
  }), _vm._v(" "), _c('leaderboard', {
    attrs: {
      "gid": _vm.gid
    }
  }), _vm._v(" "), _c('rating-history-card', {
    attrs: {
      "gid": _vm.gid,
      "uid": _vm.uid
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-container"
  }, [_c('info-card', {
    attrs: {
      "title": _vm.$t('pages.ratingHistory.currentRating'),
      "icon": "glyphicon glyphicon-stats",
      "iconColor": "#0073b7",
      "value": _vm.rating
    }
  }), _vm._v(" "), (_vm.ratingDeviation <= 70) ? _c('info-card', {
    attrs: {
      "title": _vm.$t('pages.exams.ratingResults.ratingAccuracy'),
      "icon": "fa fa-bullseye",
      "iconColor": "#0073b7",
      "value": Math.round((1 - _vm.ratingDeviation / 350) * 100) + '%'
    }
  }) : (_vm.ratingDeviation <= 180) ? _c('info-card', {
    attrs: {
      "title": _vm.$t('pages.exams.ratingResults.ratingAccuracy'),
      "icon": "fa fa-bullseye",
      "iconColor": "#f39c12",
      "value": Math.round((1 - _vm.ratingDeviation / 350) * 100) + '%'
    }
  }) : _c('info-card', {
    attrs: {
      "title": _vm.$t('pages.exams.ratingResults.ratingAccuracy'),
      "icon": "fa fa-bullseye",
      "iconColor": "#dd4b39",
      "value": Math.round((1 - _vm.ratingDeviation / 350) * 100) + '%'
    }
  }), _vm._v(" "), (_vm.solvedExercises / _vm.allExercises < 1) ? _c('info-card', {
    attrs: {
      "title": "Resene naloge",
      "icon": "fa fa-list",
      "iconColor": "#0073b7",
      "value": _vm.solvedExercises + '/' + _vm.allExercises
    }
  }) : _c('info-card', {
    attrs: {
      "title": "Resene naloge",
      "icon": "fa fa-list",
      "iconColor": "#00a65a",
      "value": _vm.solvedExercises + '/' + _vm.allExercises
    }
  })], 1), _vm._v(" "), (_vm.ratingHistory.length > 0) ? _c('graph', {
    attrs: {
      "ratingHistory": _vm.ratingHistory
    }
  }) : _vm._e(), _vm._v(" "), (_vm.histogram) ? _c('histogram', {
    attrs: {
      "histogram": _vm.histogram,
      "rating": _vm.rating
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7ac93152", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ac93152"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rating/UserRating.vue
// module id = 1455
// module chunks = 1